import { combineReducers } from "redux-immutable";
import { connectRouter } from "connected-react-router";
import appReducer from "./app-reducer";
import reviewReducer from "./review-reducer";
import settingsReducer from "./settings-reducer";
import campaignReducer from "./campaign-reducer";
import importFile from "./import-reducer";
import reportEmail from "./report-email-reducer";
import listProduct from "./list-product-reducer";
import dataBlog from "./blog-reducer";
import popupReviewReducer from "./popup-review-reducer";
import snippetReducer from "./snippet-reducer";
import customerSayReducer from "./customer-say-reducer";
import pricingReducer from "./pricing-reducer";

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    appReducer,
    reviewReducer,
    settingsReducer,
    campaignReducer,
    importFile,
    reportEmail,
    listProduct,
    dataBlog,
    popupReviewReducer,
    snippetReducer,
    pricingReducer,
    customerSayReducer,
  });
